import { render, staticRenderFns } from "./ResultContainer.vue?vue&type=template&id=7cf0e5ea&"
import script from "./ResultContainer.vue?vue&type=script&lang=js&"
export * from "./ResultContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cf0e5ea')) {
      api.createRecord('7cf0e5ea', component.options)
    } else {
      api.reload('7cf0e5ea', component.options)
    }
    module.hot.accept("./ResultContainer.vue?vue&type=template&id=7cf0e5ea&", function () {
      api.rerender('7cf0e5ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/Games/ResultContainer.vue"
export default component.exports